import { createFileRoute } from '@tanstack/react-router'

import { NnppReportsPage } from '@/src/pages/nnpp/reports/NnppReportsPage'

export const Route = createFileRoute('/nnpp/reports/')({
  component: NnppReportsPage,
  staticData: {
    layout: { enableScrolling: true },
  },
})
